import { DcrEntityType, Hcphco } from '@/core/graphql/generated/types';

export const processEntityData = (entityData: string, type: DcrEntityType) => {
	const parsedData = JSON.parse(entityData);

	return {
		__typename: type,
		...parsedData
	} as Hcphco;
};
